<!-- Hero Section -->
<section id="hero">
  <app-inventory-hero></app-inventory-hero>
</section>

<!-- Overview Section -->
<section id="overview">
  <app-inventory-overview></app-inventory-overview>
</section>

<!-- Features Section -->
<section id="features">
  <app-inventory-features></app-inventory-features>
</section>
